import {
  Grid,
  InputAdornment,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { getSchoolSectors, getBusinessesSectors } from '@webapps/business';
import {
  Button,
  FormikAutocompletePx,
  FormikTextFieldPx,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useState } from 'react';

import Modal from 'components/Modal';
import AddPartner from './AddPartner';

const FilterPartners = ({ formik = {}, partners, refetch, accept }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [openInternalPartner, setOpenInternalPartner] = useState(false);

  const { data: domains = [] } = useQuery(getBusinessesSectors, {
    key: 'allSectorsJobs',
  });

  const { data: sectors = [] } = useQuery(getSchoolSectors, {
    key: 'allSectorsSchools',
  });

  const type = [
    { label: 'Interne', value: 'internal' },
    { label: 'Externe', value: 'external' },
  ]

  return (
    <>
      <div
        className={css({
          display: 'flex',
          flexWrap: 'wrap',
          gap: spacing(1),
          '@media (max-width: 768px)': {
            flexDirection: 'column',
          },
        })}
      >
        <div
          className={css({
            display: 'flex',
            gap: spacing(1),
            '@media (max-width: 768px)': {
              width: '100%',
              flexDirection: 'column',
            },
          })}
        >
          <div
            className={css({
              flexGrow: 1,
              '@media (max-width: 768px)': {
                flexGrow: 1,
              },
            })}
          >
            <FormikTextFieldPx
              fullWidth
              formik={formik}
              variant="outlined"
              borderRadius={400}
              name="keyword"
              label="Nom de l'entreprise"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Search style={{ color: '#5D75A8' }} />
                  </InputAdornment>
                ),
                className: css({
                  width: '220px',
                  '@media (max-width: 768px)': {
                    width: '100% !important',
                  },
                }),
              }}
            />
          </div>
        </div>


        <div
          className={css({
            // flex: '1 1 18%',
            // minWidth: '220px',
          })}
        >
          <FormikAutocompletePx
            formik={formik}
            // fullWidth
            getOptionLabel={(option) => option.label || ''}
            label="Domaine(s) professionnel(s)"
            name="domains"
            options={domains}
            pathValue="id"
            value={domains.find((domain) => domain.id === formik.values.domains) || null}
            className={css({
              width: '220px',
              '@media (max-width: 768px)': {
                width: '100% !important',
              },
            })}
          />
        </div>

        <div
          className={css({
            // flex: '1 1 18%',
            // minWidth: '220px',
          })}
        >
          <FormikAutocompletePx
            formik={formik}
            // fullWidth
            getOptionLabel={(option) => option.label || ''}
            label="Secteur(s) d'activité(s)"
            name="sectors"
            options={sectors}
            pathValue="id"
            value={sectors.find((sector) => sector.id === formik.values.sectors) || null}
            className={css({
              width: '220px',
              '@media (max-width: 768px)': {
                width: '100% !important',
              },
            })}
          />
        </div>

        {accept && (
          <div
            className={css({
              // flex: '1 1 18%',
              // minWidth: '220px',
              '@media (max-width: 768px)': {
                width: '100%',
              },
            })}
          >
            <FormikAutocompletePx
              formik={formik}
              // fullWidth
              getOptionLabel={(option) => option.label || ''}
              label="Type de partenaire"
              name="type"
              options={type}
              // className={classes.btn}
              value={formik.values.type}
              className={css({
                width: '220px',
                '@media (max-width: 768px)': {
                  width: '100% !important',
                },
              })}
            />
          </div>
        )}

        {partners.length > 0 && (
          <div
            className={css({
              // flex: '1 1 18%',
              minWidth: '220px',
              '@media (max-width: 525px)': {
                flex: '1 1 100%',
              },
            })}
          >
            <Button
              color="primary"
              onClick={() => setOpenInternalPartner(true)}
              variant="contained"
              disableElevation={true}
              // fullWidth
              // className={classes.btn}
              className={css({
                width: '220px',
                '@media (max-width: 768px)': {
                  width: '100%',
                },
              })}
            >
              Ajouter une entreprise
            </Button>
          </div>
        )}
      </div>

      <Modal
        onCancel={() => setOpenInternalPartner(false)}
        open={openInternalPartner}
        title="Ajouter une entreprise"
        width="1200px"
      >
        <AddPartner
          onClose={() => setOpenInternalPartner(false)}
          refetch={refetch}
        />
      </Modal>
    </>
  );
};

const styles = ({ spacing }) => ({
  container: {
    columnGap: 10,
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column',
      columnGap: 0,
      rowGap: 10,
    },
  },
});

export default FilterPartners;
